<template>
    <span :class="additionalClasses">
        <svg :width="width" :height="height" viewBox="0 0 18 18" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M9.1179 0.900024C5.5738 0.900024 2.69995 3.77387 2.69995 7.31798C2.69995 9.07599 3.40596 10.668 4.55116 11.8273C5.71423 13.0057 7.42756 15.2309 9.1179 17.1C10.7993 15.2309 12.5675 12.9852 13.7344 11.7762C14.849 10.6221 15.5359 9.05046 15.5359 7.31798C15.5359 3.77387 12.662 0.900024 9.1179 0.900024ZM9.1179 9.08876C7.94845 9.08876 7.00114 8.14145 7.00114 6.97199C7.00114 5.80254 7.94845 4.85523 9.1179 4.85523C10.2874 4.85523 11.2347 5.80254 11.2347 6.97199C11.2347 8.14145 10.2874 9.08876 9.1179 9.08876Z"
                fill="currentColor"
            />
        </svg>
    </span>
</template>

<script>
export default {
    name: 'GeoIcon',
    props: {
        width: {
            type: Number,
            default: 18
        },
        height: {
            type: Number,
            default: 18
        },
        additionalClasses: {
            type: String,
            default: 'text-grey-700'
        }
    }
}
</script>
